/**
 * Accessors over `window.__CONFIG__`, the SSR payload the dashboard-finitless
 * Worker injects into index.html
 */

let cached;

const readInjectedConfig = () => {
  if (cached !== undefined) {
    return cached;
  }

  if (typeof window === "undefined") {
    cached = null;
    return cached;
  }

  const raw = window.__CONFIG__;
  cached = raw && typeof raw === "object" ? raw : null;
  return cached;
};

export const getInjectedConfig = () => readInjectedConfig();

export const getWhiteLabelProject = () => {
  const config = readInjectedConfig();
  const code = config?.project?.code;
  return typeof code === "string" && code.trim() ? code.trim() : null;
};

export const getWhiteLabelProjectInfo = () => {
  const config = readInjectedConfig();
  return config?.project || null;
};

export const getWhiteLabelApiUrl = () => {
  const config = readInjectedConfig();
  const url = config?.api_url;
  return typeof url === "string" && url.trim() ? url.trim() : null;
};

export const getWhiteLabelConfigs = () => {
  const config = readInjectedConfig();
  const configs = config?.configs;
  return configs && typeof configs === "object" ? configs : null;
};

export const getWhiteLabelConfigValue = (key) => {
  const value = getWhiteLabelConfigs()?.[key]?.value;
  return typeof value === "string" && value.trim() ? value.trim() : null;
};

export const isWhiteLabel = () => getWhiteLabelProject() !== null;

export const getBrandLogo = (fallback = null) =>
  isWhiteLabel() ? getWhiteLabelConfigValue("dashboard_logo") : fallback;

export const getBrandIcon = (fallback = null) =>
  isWhiteLabel() ? getWhiteLabelConfigValue("dashboard_favicon") : fallback;

export const getBrandName = (fallback = null) =>
  isWhiteLabel() ? getWhiteLabelConfigValue("dashboard_title") : fallback;

export const resetWhiteLabelConfigCache = () => {
  cached = undefined;
};
